import { ColumnDef } from "@tanstack/react-table";
import { Checkbox } from "~/components/ui/checkbox";
import { format } from "date-fns";

export const columns: ColumnDef<any>[] = [
  {
    id: "select",
    header: ({ table }) => (
      <Checkbox
        checked={table.getIsAllPageRowsSelected()}
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "reference",
    header: "Reference",
  },
  {
    accessorKey: "title",
    header: "Title",
  },
  {
    accessorKey: "siteName",
    header: "Site",
  },
  {
    accessorKey: "evaluatorName",
    header: "Evaluator",
  },
  {
    accessorKey: "assessmentDate",
    header: "Assessment Date",
    cell: ({ row }) => {
      const date = row.getValue("assessmentDate") as string;
      return date ? format(new Date(date), "dd/MM/yyyy") : "-";
    },
  },
  {
    accessorKey: "nextReviewDate",
    header: "Next Review Date",
    cell: ({ row }) => {
      const date = row.getValue("nextReviewDate") as string;
      return date ? format(new Date(date), "dd/MM/yyyy") : "-";
    },
  },
];
